import {EntryKind} from '../../../../journal/src/_interface/entry-kind.enum';
import {SettingRow} from 'app/_interfaces/settings.interface';

export const JournalDefaultSettings: SettingRow[] = [
	{
		key: 'journal.overview.entriesLimit',
		persistent: true,
		value: 100
	},
	{
		key: 'journal.foldedAll',
		persistent: true,
		value: true
	},
	{
		key: 'journal.list.entriesPerPage',
		persistent: true,
		value: 10
	},
	{
		key: 'journal.fromDate',
		persistent: true,
		value: '2020-01-01T00:00:00.000Z'
	},
	{
		key: 'journal.toDate',
		persistent: false,
		value: new Date().toISOString()
	},
	{
		key: 'journal.edit.defaultTemplate',
		persistent: true,
		value: EntryKind.Medicine
	},
	{
		key: 'journal.focusSchema',
		persistent: true,
		value: true
	},
	{
		key: 'journal.unfoldContent',
		persistent: true,
		value: true
	},
	{
		key: 'journal.foldContentLinesNumber',
		persistent: true,
		value: 3
	},
	{
		key: 'journal.entryTypeExtended',
		persistent: true,
		value: null
	}
];
